import { Observable, of } from 'rxjs';
import { Injectable, makeStateKey, TransferState, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { NotificationModel } from '@app/pages/notifications/models/notification-model';
import { HttpBaseService } from '../base_services/http_base.service';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { activeUserModel } from '@shared/model/customerModels/customer-model';
import { ActivityPluseAggrigatorModel } from '@shared/model/activity-plus-aggrigator-model';
import { SearchFilterModel } from '@shared/model/categoryAndSearch/search-filter-model';
import { catchError, switchMap } from 'rxjs/operators';

import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { FeedUsersModel } from '@shared/model/feed-users-model';


const STATE_KEY_POPULAR_USRES_HOME = makeStateKey<TServiceResult<PageList<activeUserModel>>>('popular_users_home');
const STATE_KEY_ACTIVE_USRES_HOME = makeStateKey<TServiceResult<PageList<activeUserModel>>>('active_users_home');


@Injectable({
  providedIn: "root",
})
export class ActivitiesAggrigatorService extends HttpBaseService {
  private serverState = inject(TransferState);

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, "v1/ActAggr");
  }


  getMyActivities(TF?: TermFilterModel): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(`${this.apiUrl}/GetMyActivities`, TF);
  }

  getMyFeeds(
    TF?: TermFilterModel
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
      `${this.apiUrl}/GetMyFeeds`,
      TF
    );
  }


  getMyAggregateFeeds(TF?: TermFilterModel): Observable<TServiceResult<PageList<ActivityPluseAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivityPluseAggrigatorModel>>>(`${this.apiUrl}/GetMyAggregateFeeds`, TF);
  }

  getMyNotifications(TF?: TermFilterModel): Observable<TServiceResult<PageList<NotificationModel>>> {
    return this.http.post<TServiceResult<PageList<NotificationModel>>>(`${this.apiUrl}/GetMyAggregateNotifsV2`, TF);
  }

  // ! Not Use Yet
  getGuestActivities(
    userId: string
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
      `${this.apiUrl}/GetGuestActivities/${userId}`,
      null
    );
  }

  getGuestUserActivities(
    userId: string,
    termFilter?: TermFilterModel
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    const paramsValues = this.TermFilterParams(termFilter);
    return this.http
      .get<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
        `${this.apiUrl}/GetGuestUserActivities/${userId}${paramsValues}`
      )
      .pipe(
        catchError(() => {
          return of(
            new TServiceResult<PageList<ActivitiesAggrigatorModel>>(
              new PageList(),
              "",
              null,
              true,
              ""
            )
          );
        })
      );
  }

  getAuthorActivities(TF?: TermFilterModel): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(`${this.apiUrl}/GetAuthorActivities`, TF);
  }

  getPublisherFeedBacks(TF?: TermFilterModel): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(`${this.apiUrl}/GetPublisherActivities`, TF);
  }

  //? depericated
  getmostActiveUsers(): Observable<TServiceResult<PageList<activeUserModel>>> {
    return this.http
      .post<TServiceResult<PageList<activeUserModel>>>(
        `${this.apiUrl}/GetMostActiveUsers`,
        null
      )
      .pipe(
        switchMap((res) => {
          if (!res.hasError) {
            this.serverState.set(STATE_KEY_ACTIVE_USRES_HOME, res);
          }
          return of(res);
        })
      );
  }

  //? depericated
  getMostActiveUsersWithState(): Observable<TServiceResult<PageList<activeUserModel>>> {
    return this.http.post<TServiceResult<PageList<activeUserModel>>>(`${this.apiUrl}/GetMostActiveUsersWithState`, null);
  }

  getPopularUsers(): Observable<TServiceResult<PageList<activeUserModel>>> {
    return this.http
      .post<TServiceResult<PageList<activeUserModel>>>(
        `${this.apiUrl}/GetPopularUsers`,
        null
      )
      .pipe(
        switchMap((res) => {
          if (!res.hasError) {
            this.serverState.set(STATE_KEY_POPULAR_USRES_HOME, res);
          }
          return of(res);
        })
      );
  }

  getPopularUsersWithState(): Observable<
    TServiceResult<PageList<activeUserModel>>
  > {
    return this.http.post<TServiceResult<PageList<activeUserModel>>>(
      `${this.apiUrl}/GetPopularUsersWithState`,
      null
    );
  }

  getMyActivitiesOnBook(
    bookId: string,
    termFilter?: TermFilterModel
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
      `${this.apiUrl}/GetMyActivitiesOnBook/${bookId}`,
      termFilter
    );
  }

  // ? isReverse === از این به قبل رو میاره - از تاریخ اعلام شده به قبل
  getMyAggregateFeedsByDate(
    searchFilter?: SearchFilterModel,
    isReverse?: boolean,
    fetchDate?: string
  ): Observable<TServiceResult<PageList<ActivityPluseAggrigatorModel>>> {
    let params = "";
    if (isReverse != undefined) {
      params = `?isReverse=${isReverse}`;
    }
    if (fetchDate != undefined) {
      params += `&fetchDate=${fetchDate}`;
    }
    return this.http.post<
      TServiceResult<PageList<ActivityPluseAggrigatorModel>>
    >(`${this.apiUrl}/GetMyAggregateFeedsByDate${params}`, searchFilter);
  }

  // ? isReverse === از این به قبل رو میاره - از تاریخ اعلام شده به قبل
  getMyAggregateFeedsByDateV2(
    actorId?: string,
    searchFilter?: SearchFilterModel,
    isReverse?: boolean,
    fetchDate?: string
  ): Observable<TServiceResult<PageList<ActivityPluseAggrigatorModel>>> {
    let params = "?";
    if (actorId != undefined) {
      params += `actorId=${actorId}&`;
    }
    if (isReverse != undefined) {
      params += `isReverse=${isReverse}&`;
    }
    if (fetchDate != undefined) {
      params += `fetchDate=${fetchDate}&`;
    }
    return this.http.post<
      TServiceResult<PageList<ActivityPluseAggrigatorModel>>
    >(
      `${this.apiUrl}/GetMyAggregateFeedsByDateV2${params}`,
      searchFilter || {}
    );
  }

  // ? Club Active Course activities
  getCourseActivities(
    courseId: string,
    termFilter: TermFilterModel
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    const verbsString = `verb=${ActivityVerbEnum.Reviewed}&verb=${ActivityVerbEnum.Rated}&verb=${ActivityVerbEnum.ReadingProgressed}&verb=${ActivityVerbEnum.StateChangedToRead}`;
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
      `${this.apiUrl}/GetCourseActivities/${courseId}?${verbsString}`,
      termFilter
    );
  }

  // ? Club Admins Activities
  getClubActivities(
    clubId: string,
    filters: TermFilterModel
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
      `${this.apiUrl}/GetClubActivities/${clubId}`,
      filters
    );
  }

  getAggregatedFeedUser(
    searchFilter?: SearchFilterModel,
    isReverse?: boolean,
    fetchDate?: string
  ): Observable<TServiceResult<PageList<FeedUsersModel>>> {
    let params = "";
    if (isReverse != undefined) {
      params = `?isReverse=${isReverse}`;
    }
    if (fetchDate != undefined) {
      params += `&fetchDate=${fetchDate}`;
    }
    return this.http.post<TServiceResult<PageList<FeedUsersModel>>>(
      `${this.apiUrl}/GetAggregatedFeedUser${params}`,
      searchFilter
    );
  }

  GetGuestActivitiesOnBook(
    term: string,
    bookId: string,
    filter: TermFilterModel
  ): Observable<TServiceResult<PageList<ActivitiesAggrigatorModel>>> {
    return this.http.post<TServiceResult<PageList<ActivitiesAggrigatorModel>>>(
      `${this.apiUrl}/GetGuestActivitiesOnBookV2/${term}/${bookId}`,
      filter
    );
  }
}
